import { PreWraper } from '@components/shared/wraper/PreWraper'

type Props = {
  description: string
  cardRowNum: number
  size?: 'small' | 'medium'
}

export const ProgramCardDescription = ({
  description,
  cardRowNum,
  size,
}: Props): JSX.Element => (
  <div
    className={`${
      cardRowNum === 3
        ? size === 'small'
          ? 'lg:h-[2.9vw] h-[6vw]'
          : 'lg:h-[3.9vw] h-[5.5vw]'
        : cardRowNum === 4
        ? size === 'small'
          ? 'h-[7.1vw] lg:h-[2.3vw]'
          : 'h-[7.1vw] lg:h-[2.8vw]'
        : ''
    } flex overflow-hidden flex-col justify-start items-center w-full text-center border-b border-white font-normal`}
  >
    <PreWraper
      text={description}
      classes={`whitespace-pre text-[2.7vw] lg:text-[1.1vw] ${
        cardRowNum === 3 ? 'pt-[9vw] lg:pt-0' : 'lg:text-[1vw]'
      }`}
    />
  </div>
)
